import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-confirm-delete-kiosk-mode',
	templateUrl: './confirm-delete-kiosk-mode.component.html',
	styleUrls: ['./confirm-delete-kiosk-mode.component.scss'],
})
export class ConfirmDeleteKioskModeComponent {
	constructor(private dialogRef: MatDialogRef<ConfirmDeleteKioskModeComponent>) {}

	buttonAction(action) {
		this.dialogRef.close(action);
	}
}
